import { useNavigate } from 'react-router-dom';
import { signOut } from '@paulownia/shared/lib/auth';
import { useFirebaseAuth } from '@paulownia/shared/lib/auth';
import { Button } from '@paulownia/shared/components/ui/button';
import { LogOut, Store } from 'lucide-react';
import { OnboardingWizard } from '@/features/onboarding';

/**
 * Onboarding page for new merchants.
 *
 * This page is shown to authenticated users who don't have any tenant access.
 * It hosts the OnboardingWizard component which guides users through:
 * 1. Business information setup
 * 2. Market selection
 * 3. Confirmation and account creation
 */
export function Onboarding() {
  const navigate = useNavigate();
  const { user } = useFirebaseAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="flex-shrink-0 bg-white border-b px-4 py-3">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
              <Store className="w-4 h-4 text-orange-600" />
            </div>
            <span className="font-semibold text-gray-900">Paulownia</span>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500 hidden sm:inline">
              {user?.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSignOut}
              className="text-gray-600"
            >
              <LogOut className="w-4 h-4" />
              <span className="ml-2 hidden sm:inline">Déconnexion</span>
            </Button>
          </div>
        </div>
      </header>

      {/* Main content - Wizard */}
      <main className="flex-1 flex flex-col min-h-0">
        <div className="flex-1 w-full max-w-2xl mx-auto bg-white shadow-sm border-x flex flex-col min-h-0">
          <OnboardingWizard />
        </div>
      </main>
    </div>
  );
}
